import React from 'react';
import Icons from '../../../Icons/Icons';
import { isSet } from '../../../../Utils/CommonFunctions';
// import elementsProperties from './elementsProperties';


const ScmCondtion = (props)=>{
    const {elementData} = props;
    let scmCondtionValue = (isSet(elementData.data,null)!==null)?elementData.data:'';
    let conditions = elementData.conditions;
    return(
        <div className="w-100">
            {
                isSet(conditions,[]).length === 0?
                <div className="input-group mb-3">  
                    <div className="input-group-prepend cursor-pointer">
                        <span className="input-group-text text-truncate" style={{minWidth:'100px'}}  onClick={()=>props.showFilterContent(true)}>Add Condtion</span>
                    </div>                                          
                </div>
                :
                <div className="input-group mb-3">  
                    <a className="cursor-pointer" onClick={e=>props.showFilterContent()}><Icons iconType="Edit" /></a>
                    <p>{scmCondtionValue}</p>               
                </div>
            }                                        
        </div>
    )
}
export default ScmCondtion;